import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

/** @type {string?} */
const initialState = null;

/** @returns {null} */
const reset = () => null;

/**
 * @param {string?} _
 * @param {import('modules/statistics/types').FetchChatStatisticsFailureAction} action
 * @returns {string}
 */
const setError = (_, { payload }) => payload;

export default createReducer(initialState, {
  [types.FETCH_CHAT_STATISTICS_REQUEST]: reset,
  [types.FETCH_CHAT_STATISTICS_FAILURE]: setError,
});
